export default "__VITE_ASSET__B7t4429y__"